/* istanbul ignore file */
import { EmployeeDropdown } from 'domain/shared/employee';

const PeopleManagerDropdown = (props: any) => {
  return <EmployeeDropdown filter={{ 'specification:peopleManagerSpecification': { eq: true } }} {...props} />;
};

export default PeopleManagerDropdown;
